import { useEffect, useState } from 'react';
import { api } from '../../../apis/api';
import { InvoiceDocument } from '../../components/invoiceDocument/invoiceDocument';
import '../orders/orders.css';
import '../categories/categories.css';
import '../../components/invoiceDocument/invoiceDocument.css';

const formatINR = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;
const formatDate = (d) => (d ? new Date(d).toLocaleString('en-IN') : '—');

export const Invoices = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [viewing, setViewing] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [downloadingId, setDownloadingId] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.getOrders();
      setOrders(Array.isArray(res.data) ? res.data : []);
      setError('');
    } catch (err) {
      setOrders([]);
      setError(err.message || 'Failed to load invoices');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const openInvoice = async (orderId) => {
    setViewLoading(true);
    try {
      const res = await api.getOrder(orderId);
      setViewing(res.data);
    } catch (err) {
      alert(err.message || 'Failed to load invoice');
    } finally {
      setViewLoading(false);
    }
  };

  const downloadInvoice = async (orderId, invoiceNo) => {
    setDownloadingId(orderId);
    try {
      await api.downloadInvoicePdf(orderId, invoiceNo);
    } catch (err) {
      alert(err.message || 'Failed to download invoice');
    } finally {
      setDownloadingId(null);
    }
  };

  if (loading) return <p className="admin-loading">Loading invoices…</p>;
  if (error) return <p className="admin-error">{error}</p>;

  return (
    <div className="admin-invoices">
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>INVOICE NO</th>
              <th>CUSTOMER</th>
              <th>EMAIL</th>
              <th>TOTAL</th>
              <th>EMAIL SENT</th>
              <th>DATE</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 ? (
              <tr><td colSpan={7}>No invoices yet</td></tr>
            ) : (
              orders.map((o) => (
                <tr key={o.order_id}>
                  <td>{o.invoice_no}</td>
                  <td>{o.customer_name}</td>
                  <td>{o.customer_email}</td>
                  <td>{formatINR(o.total)}</td>
                  <td>
                    <span className={`status-badge ${o.email_sent ? 'status--delivered' : 'status--pending'}`}>
                      {o.email_sent ? 'Sent' : 'Pending'}
                    </span>
                  </td>
                  <td>{formatDate(o.created_at)}</td>
                  <td className="admin-table__actions">
                    <button
                      type="button"
                      className="admin-btn admin-btn--outline"
                      onClick={() => openInvoice(o.order_id)}
                      disabled={viewLoading}
                    >
                      View Invoice
                    </button>
                    <button
                      type="button"
                      className="admin-btn admin-btn--outline"
                      onClick={() => downloadInvoice(o.order_id, o.invoice_no)}
                      disabled={downloadingId === o.order_id}
                    >
                      {downloadingId === o.order_id ? '…' : 'PDF'}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {viewing && (
        <div className="admin-modal-backdrop" onClick={() => setViewing(null)}>
          <div
            className="admin-modal admin-invoice-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="admin-invoice-modal__toolbar">
              <button
                type="button"
                className="admin-btn admin-btn--primary"
                onClick={() => downloadInvoice(viewing.order_id, viewing.invoice_no)}
                disabled={downloadingId === viewing.order_id}
              >
                {downloadingId === viewing.order_id ? 'Downloading…' : 'Download Invoice PDF'}
              </button>
              <button
                type="button"
                className="admin-btn admin-btn--outline"
                onClick={() => setViewing(null)}
              >
                Close
              </button>
            </div>
            <InvoiceDocument order={viewing} />
          </div>
        </div>
      )}
    </div>
  );
};
